<template>
    <div>
        <b-table
            :fields="fields"
            :items="items"
            :class="['gk-table gk-table--responsive gk-table--striped gk-table--headed']"
            :busy="loading"
            :thead-class="items && items.length ? '': 'd-none'"
            show-empty
            table-busy>
            <template #empty="">
                <EmptyState>
                    <template v-slot:image>
                        <img src="/static/img/empty-states/empty-state-cost.png">
                    </template>
                    <template v-slot:title>
                        {{ $gettext('Loading...') }}
                    </template>
                    <template v-slot:cta>
                    <GekkoButton 
                        :text="$gettext('Go to invoices')"
                        icon="fa-solid fa-file-lines"
                        :to="{ name: 'Invoices' }" 
                    />
                    </template>
                </EmptyState>
            </template>

            <template #cell()="data">
                <span v-if="[0, 3, 6].includes(data.index)" style="font-weight: bold;">
                    {{ formatNumber(data.value) }}
                    <span v-if="data.index === 0 && data.field.key === 'text_label'">
                        <font-awesome-icon id="tooltip-net-income" class="tooltip-icon tooltip-icon--question" icon="fa-regular fa-circle-question" />
                        <b-tooltip :custom-class="'tooltip-padded'" target="tooltip-net-income" triggers="hover" container="#report-container">
                            <div class="tooltip-title">
                                {{ $gettext('Net Income') }}
                            </div>
                            <div class="tooltip-text">
                                {{ $gettext('All totals are excluding VAT.') }}
                            </div>
                        </b-tooltip>
                    </span>
                    <span v-if="data.index === 3 && data.field.key === 'text_label'">
                        <font-awesome-icon id="tooltip-unpaid-invoices" class="tooltip-icon tooltip-icon--question" icon="fa-regular fa-circle-question" />
                        <b-tooltip :custom-class="'tooltip-padded'" target="tooltip-unpaid-invoices" triggers="hover" container="#report-container">
                            <div class="tooltip-title">
                                {{ $gettext('Net Expenses') }}
                            </div>
                            <div class="tooltip-text">
                                {{ $gettext('All totals are excluding VAT.') }}
                            </div>
                        </b-tooltip>
                    </span>
                </span>
                <span v-else>{{ formatNumber(data.value) }}</span>
            </template>
        </b-table>
    </div>
</template>

<script>
import EmptyState from "@/components/ui/EmptyState"
import GekkoButton from "@/components/GekkoButton"

export default {
    name: 'CashFlowTable',
    components: {EmptyState, GekkoButton},
    props: {
        revenueData: {
            type: Array,
            default: () => []
        },
        year: {
            type: String,
            default: () => ''
        },
        yearData: {
            type: Object,
            default: () => {}
        }
    },
    watch: {
        revenueData() {
            this.setData()
            this.loading = false
        }
    },
    data() {
        return {
            items: [],
            fields: [],
            loading: true
        }
    },
    methods: {
        setData() {
            this.fields = []
            this.items = []

            let netIncome = {}
            let paidInvoices = {}
            let unpaidInvoices = {}
            let paidBills = {}
            let netExpenses = {}
            let unpaidExpenses = {}
            let margin = {}

            this.fields.push({key: 'text_label', label: ''})
            netIncome = {'text_label': this.$gettext('Net Income ')}
            paidInvoices = {'text_label': this.$gettext('Paid invoices')}
            unpaidInvoices = {'text_label': this.$gettext('Unpaid invoices')}
            paidBills = {'text_label': this.$gettext('Net Expenses')}
            netExpenses = {'text_label': this.$gettext('Paid bills')}
            unpaidExpenses = {'text_label': this.$gettext('Unpaid expenses')}
            margin = {'text_label': this.$gettext('Margin')}

            this.revenueData.forEach(x => {
                this.fields.push({key: x.label, thClass: 'text-right', tdClass: 'text-right'})
                netIncome[x.label] = x.income + x.unpaidincome
                paidInvoices[x.label] = x.income
                unpaidInvoices[x.label] = x.unpaidincome
                paidBills[x.label] = x.expenses
                unpaidExpenses[x.label] = x.unpaidexpenses
                netExpenses[x.label] = x.expenses + x.unpaidexpenses
                margin[x.label] = x.margin
            })

            this.fields.push({key: 'year', label: this.year, thClass: 'text-right', tdClass: 'text-right'})

            netIncome['year'] = this.yearData.income + this.yearData.unpaidincome
            paidInvoices['year'] = this.yearData.income
            unpaidInvoices['year'] = this.yearData.unpaidincome
            paidBills['year'] = this.yearData.expenses
            unpaidExpenses['year'] =this.yearData.unpaidexpenses
            netExpenses['year'] = this.yearData.expenses
            margin['year'] = this.yearData.margin

            this.items.push(netIncome)
            this.items.push(paidInvoices)
            this.items.push(unpaidInvoices)
            this.items.push(paidBills)
            this.items.push(netExpenses)
            this.items.push(unpaidExpenses)
            this.items.push(margin)
        },
        formatNumber(num) {
            try{
                num = parseInt(num.toFixed(0))
                let str = num.toLocaleString('en-US')
                return `€ ${str}`
            } catch (err) {
                return num
            }
        }
    }
}
</script>